import { useEffect, useRef } from "react";
import { composeChannelCategoryContextData, createCompetitionContext } from "../../../../libraries/_modules/tracking/snowplow/snowplowTracking";
import { trackPageView } from "../../../../libraries/_modules/tracking/snowplow/snowplowEventTrackers";

function useTrackMatchList({
    competitionSportecId,
    mlsCompetitions = [],
    seasonSportecId,
}) {
    const isTracked = useRef(false);

    useEffect(() => {
        if (competitionSportecId && mlsCompetitions?.length && seasonSportecId && !isTracked.current) {
            const competition = mlsCompetitions.find(competition => competition.competition_id === competitionSportecId);

            if (competition) {
                const competitionContext = createCompetitionContext({
                    competition_id: competition.competition_id,
                    competition_name: competition.competition_name,
                    season: seasonSportecId,
                    start_date: competition.start_date,
                    end_date: competition.end_date,
                    number_of_teams: competition.number_of_teams || 0,
                });

                const channelCategoryContext = composeChannelCategoryContextData();

                trackPageView({
                    contexts: [competitionContext, channelCategoryContext,],
                });

                isTracked.current = true;
            }
        }
    }, [competitionSportecId, mlsCompetitions, seasonSportecId]);
}


export default useTrackMatchList;